import { createSlice } from "@reduxjs/toolkit";

interface ReportesInterface {
  libroIndiceRes: any[];
  letraSelected: number | null;
}

const initialState: ReportesInterface = {
  libroIndiceRes: [],
  letraSelected: 0,
};

export const libroIndiceSlice = createSlice({
  name: "Libro Indice",
  initialState,
  reducers: {
    onAddLetraSelected: (state, { payload }) => {
      state.letraSelected = payload;
    },
    onAddLibroIndiceResponse: (state, { payload }) => {
      state.libroIndiceRes = payload;
    },
    onResetLibroIndice:(state)=>{
      state.libroIndiceRes = [];
      state.letraSelected = 0;
    }
  },
});

//actions creators are generated for each case reducer function
export const { onAddLetraSelected, onAddLibroIndiceResponse , onResetLibroIndice } =
  libroIndiceSlice.actions;
